import configureChart from './chart';
import configureLegend from './legend';
import configurePlotOptions from './plotOptions';
import configureSeries from './series/main';
import configureTitle from './title';
import configureXAxis from './xAxis';
import configureYAxis from './yAxis';
import configureCredits from './credits';
import configureTooltip from './tooltip';
import configurePane from './pane';
import configureColorAxis from './colorAxis';
import configureColors from './colors';
import parseAndSortData from '../utils/sortData';

// Flag requireMultipleConfig handles Bullet chart differently from other charts
var convertToGenII = function convertToGenII(widgetConfig, seriesDataObj) {
    var customConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var requireMultipleConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var config = [];
    if (!requireMultipleConfig) {
        config.push(buildConfig(widgetConfig, seriesDataObj, customConfig));
        return config;
    } else {
        var bulletSeriesData = parseAndSortData(widgetConfig.BulletConfig.Series, widgetConfig, seriesDataObj);
        if (widgetConfig.BulletConfig.Series[0].CategoryAxis) bulletSeriesData.forEach(function (element) {
            config.push(buildConfig(widgetConfig, element, customConfig, widgetConfig.BulletConfig.Series[0]));
        });else bulletSeriesData.forEach(function (element, index) {
            config.push(buildConfig(widgetConfig, element, customConfig, widgetConfig.BulletConfig.Series[index]));
        });
        return config;
    }
};

var buildConfig = function buildConfig(widgetConfig, seriesDataObj) {
    var customConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var seriesConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var chart = customConfig.chart,
        legend = customConfig.legend,
        plotOptions = customConfig.plotOptions,
        series = customConfig.series,
        title = customConfig.title,
        xAxis = customConfig.xAxis,
        yAxis = customConfig.yAxis,
        credits = customConfig.credits,
        tooltip = customConfig.tooltip,
        pane = customConfig.pane,
        colorAxis = customConfig.colorAxis,
        colors = customConfig.colors;

    var config = {
        chart: configureChart(widgetConfig, chart),
        pane: configurePane(widgetConfig, pane),
        colorAxis: configureColorAxis(widgetConfig, colorAxis),
        legend: configureLegend(widgetConfig, seriesDataObj, legend),
        plotOptions: configurePlotOptions(widgetConfig, plotOptions),
        series: configureSeries(widgetConfig, seriesDataObj, series, seriesConfig),
        title: configureTitle(widgetConfig, title, seriesDataObj, legend),
        xAxis: configureXAxis(widgetConfig, seriesDataObj, xAxis, seriesConfig),
        yAxis: configureYAxis(widgetConfig, yAxis, seriesDataObj, seriesConfig),
        credits: configureCredits(credits),
        tooltip: configureTooltip(widgetConfig, tooltip)
    };

    if (configureColors(widgetConfig, colors)) config.colors = configureColors(widgetConfig, colors);

    return config;
};

export default { convertToGenII: convertToGenII };